// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.bookmark-popover-container .each-member .info-container .clientid, .bookmark-popover-container .title {
  font-family: "72-Condensed";
}

.bookmark-popover-container .removedCls, .bookmark-popover-container .savedCls, .bookmark-popover-container .each-member {
  font-family: "72-Regular";
}

.bookmark-popover-container .title {
  font-size: 1.4rem;
  color: #516e7f;
  padding: 1rem 0;
}
.bookmark-popover-container .line {
  height: 0.1rem;
  border-bottom: solid 1px rgba(0, 0, 0, 0.15);
}
.bookmark-popover-container .inputCls {
  top: -30%;
  position: relative;
  min-width: 72%;
  margin-left: 1rem;
  width: auto;
}
.bookmark-popover-container .inputCls:read-only {
  border: none;
}
.bookmark-popover-container li {
  list-style: none;
}
.bookmark-popover-container .each-member {
  padding: 0.5rem 1rem;
  height: 4.1rem;
  font-size: 1.2rem;
  text-align: left;
  color: #4a4a4a;
  letter-spacing: 0;
  line-height: 1.4rem;
}
.bookmark-popover-container .each-member .info-container {
  display: inline-block;
  width: calc(100% - 5rem);
  padding-left: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bookmark-popover-container .each-member .info-container p {
  padding: 0;
  margin: 0;
}
.bookmark-popover-container .each-member .info-container .clientid {
  opacity: 0.5;
  font-size: 1.1rem;
  text-align: left;
  color: #f3baba;
}
.bookmark-popover-container .each-member:before {
  content: "";
  display: inline-block;
  background-image: url('corp-avi-round.svg');
  background-size: contain;
  background-repeat: no-repeat;
  width: 2.7rem;
  height: 2.7rem;
  background-color: #ffffff;
  border: solid 0.1rem #dfe3e4;
  border-radius: 50%;
  padding: 1.4rem;
}
.bookmark-popover-container .each-member.lead-member:before {
  border: solid 0.1rem #f3bc44;
}
.bookmark-popover-container .each-member.male-member:before {
  background-image: url('male-avi-round.svg');
}
.bookmark-popover-container .each-member.female-member:before {
  background-image: url('female-avi-round.svg');
}
.bookmark-popover-container .action-container {
  margin: 1rem 0;
}
.bookmark-popover-container .action-container .link-btn {
  font-size: 1.2rem;
}
.bookmark-popover-container .savedCls {
  color: #4bb982;
}
.bookmark-popover-container .removedCls {
  color: #d0021b;
}
.bookmark-popover-container .icon-btn {
  top: -37%;
  position: relative;
}

.action-container {
  min-height: 1.8rem;
}

.cancel-btn-height {
  min-height: 28.65px;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/bookmark-popover/bookmark-popover.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAaA;EACI,2BAAA;ACfJ;;ADsBA;EACI,yBAAA;ACnBJ;;AALE;EAEE,iBAAA;EACA,cAAA;EACA,eAAA;AAOJ;AALE;EACE,cAAA;EACA,4CAAA;AAOJ;AALE;EACE,SAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;AAOJ;AANI;EACE,YAAA;AAQN;AAJE;EACE,gBAAA;AAMJ;AAHE;EACE,oBAAA;EACA,cAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAIJ;AAHI;EACE,qBAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAKN;AAJM;EACE,UAAA;EACA,SAAA;AAMR;AAJM;EACE,YAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;AAKR;AAFI;EACE,WAAA;EACA,qBAAA;EACA,2CAAA;EACA,wBAAA;EACA,4BAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;AAIN;AAFI;EACE,4BAAA;AAIN;AAFI;EACE,2CAAA;AAIN;AAFI;EACE,6CAAA;AAIN;AACE;EACE,cAAA;AACJ;AAAI;EACE,iBAAA;AAEN;AACE;EACE,cAAA;AACJ;AAEE;EACE,cAAA;AAAJ;AAIE;EACE,SAAA;EACA,kBAAA;AAFJ;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n.bookmark-popover-container {\n  .title {\n    @extend %font-condensed;\n    font-size: 1.4rem;\n    color: #516e7f;\n    padding: 1rem 0;\n  }\n  .line {\n    height: 0.1rem;\n    border-bottom: solid 1px rgba(0, 0, 0, 0.15);\n  }\n  .inputCls {\n    top: -30%;\n    position: relative;\n    min-width: 72%;\n    margin-left: 1rem;\n    width: auto;\n    &:read-only {\n      border: none;\n    }\n  }\n\n  li {\n    list-style: none;\n  }\n\n  .each-member {\n    padding: 0.5rem 1rem;\n    height: 4.1rem;\n    font-size: 1.2rem;\n    @extend %font-regular;\n    text-align: left;\n    color: #4a4a4a;\n    letter-spacing: 0;\n    line-height: 1.4rem;\n    .info-container {\n      display: inline-block;\n      width: calc(100% - 5rem);\n      padding-left: 0.5rem;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      p{\n        padding: 0;\n        margin: 0;\n      }\n      .clientid {\n        opacity: 0.5;\n        font-size: 1.1rem;\n        @extend %font-condensed;\n        text-align: left;\n        color: #f3baba;\n      }\n    }\n    &:before{\n      content: '';\n      display: inline-block;\n      background-image: url(../../../app/assets/images/corp-avi-round.svg);\n      background-size: contain;\n      background-repeat: no-repeat;\n      width: 2.7rem;\n      height: 2.7rem;\n      background-color: #ffffff;\n      border: solid 0.1rem #dfe3e4;\n      border-radius: 50%;\n      padding: 1.4rem;\n    }\n    &.lead-member:before{\n      border: solid 0.1rem #f3bc44;\n    }\n    &.male-member:before{\n      background-image: url(../../../app/assets/images/male-avi-round.svg);\n    }\n    &.female-member:before{\n      background-image: url(../../../app/assets/images/female-avi-round.svg);\n    }\n    \n  }\n\n  .action-container {\n    margin: 1rem 0;\n    .link-btn {\n      font-size: 1.2rem;\n    }\n  }\n  .savedCls {\n    color: #4bb982;\n    @extend %font-regular;\n  }\n  .removedCls {\n    color: #d0021b;\n    @extend %font-regular;\n  }\n\n  .icon-btn {\n    top: -37%;\n    position: relative;\n  }\n}\n\n.action-container{\n  min-height: 1.8rem;\n}\n\n.cancel-btn-height {\n  min-height: 28.65px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
